module.exports = __webpack_public_path__ + "img/samsung_galaxy_book_s.ad84a2b.jpg";